import { useEffect, useMemo } from 'react';
import { fillEmptyValues } from './form-values';
import { deepEqual } from 'fast-equals';
import { normalizeValues } from './normalize-values';
export const useFormValues = (form, values, onChange, config) => {
    const normalizedValues = useMemo(() => normalizeValues(form, fillEmptyValues(form, values), true, config), [form, values, config]);
    useEffect(() => {
        const hasAnyValueChanged = !deepEqual(normalizedValues, values);
        if (hasAnyValueChanged) {
            onChange?.(normalizedValues);
        }
    }, [values, normalizedValues, onChange]);
    return normalizedValues;
};
//# sourceMappingURL=use-form-values.js.map